import {commitMutation, graphql} from 'react-relay';
import type {Environment, Disposable} from 'relay-runtime';
import {csrfToken, socketClientId} from '../../../forecast-app/ticketing/graphql/forecastRelay';
import type {
	useUpdateCustomFieldDefinitionMutation,
	UpdateTicketingCustomFieldDefinitionInput,
} from './__generated__/useUpdateCustomFieldDefinitionMutation.graphql';

const mutation = graphql`
	mutation useUpdateCustomFieldDefinitionMutation($input: UpdateTicketingCustomFieldDefinitionInput!) {
		updateTicketingCustomFieldDefinition(input: $input) {
			clientMutationId
			customFieldDefinition {
				id
				name
				key
				fieldType
				options
				readOnly
				requiredOnResolution
			}
		}
	}
`;

function commit(
	environment: Environment,
	input: UpdateTicketingCustomFieldDefinitionInput,
	onCompleted?: (r: useUpdateCustomFieldDefinitionMutation['response']) => void,
	onError?: (e: Error) => void
): Disposable {
	return commitMutation<useUpdateCustomFieldDefinitionMutation>(environment, {
		mutation,
		variables: {
			input: {csrfToken: csrfToken(), socketClientId: socketClientId(), ...input},
		},
		onCompleted: onCompleted ? response => onCompleted(response) : undefined,
		onError: onError ? error => onError(error) : undefined,
	});
}

export default {commit, mutationId: 'useUpdateCustomFieldDefinitionMutation'};
